// extracted by mini-css-extract-plugin
export default {"descriptionText":"component_descriptionText__uQfnn","errorText":"component_errorText__2LZ0g"};